import { Box, Text, Flex, Link } from "@chakra-ui/react";

const Footer = () => (
  <Box
    as="footer"
    bg="tomato"
    color="white"
    py={5}
    px={{ base: 4, md: 6 }}
    borderTop="1px"
    borderColor="gray.200"
    textAlign="center"
  >
    <Flex gap={{ base: 3, lg: 6 }} align="center" justify="center" flexWrap="wrap">
      <Text fontSize="md" fontWeight="bold" lineHeight="1.5">
        TDR Software Private Limited
      </Text>
      <Flex gap={{ base: 2, md: 5 }} justify="center" flexWrap="wrap" fontSize="sm" lineHeight="1.6">
        <Text><strong>Phone:</strong> +91 9830657184</Text>
        <Text overflowWrap="anywhere">
          <strong>Email:</strong>{" "}
          <Link href="mailto:Caretdr@gmail.com" color="white">Caretdr@gmail.com</Link>
        </Text>
      </Flex>
    </Flex>
    <Text mt={3} fontSize="sm" color="whiteAlpha.800" lineHeight="1.6">
      &copy; {new Date().getFullYear()} TDR Software Private Limited. All rights reserved.
    </Text>
  </Box>
);

export default Footer;
